import { Donor } from '../../models/Donor';

export const buildDonorTitle = (donor: Donor): string => {
  const age = donor.basicInfo.age > 0 ? `${ donor.basicInfo.age }歳` : '';
  const area = donor.basicInfo.areasText[0] ?? '';
  const attributes = [ age, area ].filter((v) => v !== '').join('・');
  const suffix = attributes ? `（${ attributes }）` : '';

  return `精子ドナー${ donor.initialName }${ suffix }のプロフィール | Ton Bébé`;
};

export const buildDonorDescription = (donor: Donor): string => {
  const parts: string[] = [];

  if (donor.basicInfo.age > 0) {
    parts.push(`${ donor.basicInfo.age }歳`);
  }
  if (donor.physicalInfo.bloodType) {
    parts.push(`${ donor.physicalInfo.bloodType }型`);
  }
  if (donor.physicalInfo.height > 0 && donor.physicalInfo.weight > 0) {
    parts.push(`身長${ donor.physicalInfo.height }cm/体重${ donor.physicalInfo.weight }kg`);
  } else if (donor.physicalInfo.height > 0) {
    parts.push(`身長${ donor.physicalInfo.height }cm`);
  } else if (donor.physicalInfo.weight > 0) {
    parts.push(`体重${ donor.physicalInfo.weight }kg`);
  }

  const profileLine = parts.length > 0 ? `${ parts.join('・') }。` : '';
  const certLine = `性病検査${ donor.std.certified ? '済み' : '未検査' }・精子品質${ donor.semen.certified ? donor.semen.total : '未検査' }。`;
  const areaLine = donor.basicInfo.areasText.length > 0
    ? `対応エリア: ${ donor.basicInfo.areasText.join('・') }。`
    : '';
  const closingLine = `精子ドナー${ donor.initialName }さんのプロフィール。`;

  return `${ profileLine }${ certLine }${ areaLine }${ closingLine }`;
};
